import axiosInstance from "./axiosConfig";

export interface TagReportParams {
    startDate: string;
    endDate: string;
    dimension?: 'ad_unit' | 'date' | 'url';
    page?: number;
    pageSize?: number;
}

export interface TagReportRow {
    dimension: string;
    requests: number;
    impressions: number;
    fillRate: number;
}

export interface TagReportPagination {
    page: number;
    pageSize: number;
    totalRows?: number;
    hasMore: boolean;
}

export interface TagReportResponse {
    tag: { id: string; name: string; domain: string };
    dimension: string;
    totals: {
        requests: number;
        impressions: number;
        fillRate: number;
    };
    pagination: TagReportPagination;
    data: TagReportRow[];
}

export const getTagReport = async (tagId: string, params: TagReportParams): Promise<TagReportResponse> => {
    const queryParams = new URLSearchParams({
        startDate: params.startDate,
        endDate: params.endDate,
        ...(params.dimension ? { dimension: params.dimension } : {}),
        ...(params.page ? { page: String(params.page) } : {}),
        ...(params.pageSize ? { pageSize: String(params.pageSize) } : {}),
    });
    const response = await axiosInstance.get<TagReportResponse>(`/tag/${tagId}/report?${queryParams.toString()}`);
    return response?.data;
};
